import React from 'react'
import PropTypes from 'prop-types'
import '../../styles/RightPanel.scss'
import HeaderButton from './HeaderButton'
import Explanation from './Explanation'
import Pseudocode from './Pseudocode'
import ExtraInfo from './ExtraInfo'
import Instruction from './Instructions'
import { motion, AnimatePresence } from "framer-motion";

function RightPanel({ fontSize, fontSizeIncrement }) {
  const buttons = [
    {
      id: 0,
      label: 'Code',
      display: (
        <Pseudocode fontSize={fontSize} fontSizeIncrement={fontSizeIncrement} />
      ),
    },
    {
      id: 1,
      label: 'Background',
      display: (
        <Explanation
          fontSize={fontSize}
          fontSizeIncrement={fontSizeIncrement}
        />
      ),
    },
    {
      id: 2,
      label: 'More',
      display: (
        <ExtraInfo fontSize={fontSize} fontSizeIncrement={fontSizeIncrement} />
      ),
    },
    {
      id: 3,
      label: 'Instructions',
      display: (
        <Instruction
          fontSize={fontSize}
          fontSizeIncrement={fontSizeIncrement}
        />
      ),
    },
  ]

  const [state, setState] = React.useState(0)

  const getBtnState = (val) => {
    setState(val)
  }
  return (
    <div style={{display: "flex", height: "100%", width: "100%", flexDirection:"column", backgroundColor: "var(--right-text-bg)",}}>
      <HeaderButton value={buttons} onChange={getBtnState} />
      <AnimatePresence exitBeforeEnter>
        <motion.div
          key={state}
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -8 }}
          transition={{ duration: 0.1, ease: "easeInOut" }}
          style={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            overflow: "auto",
          }}
        >
          {buttons[state].display}
        </motion.div>
      </AnimatePresence>
    </div>
  )
}

export default RightPanel
RightPanel.propTypes = {
  fontSize: PropTypes.number.isRequired,
  fontSizeIncrement: PropTypes.number.isRequired,
}
